export const chapterComputed = {
  computed: {
    headerElStyles() {
      const { textColor, isTextInCaps } = this.module.config.header;
      const styles = {
        color: textColor.value,
        textTransform: isTextInCaps ? "uppercase" : "initial",
      };

      return styles;
    },
    textElStyles() {
      const { textColor } = this.module.config.text;
      const styles = {
        color: textColor.value,
      };

      return styles;
    },
    mediaElStyles() {
      const { corners } = this.module.config.media;
      const styles = {
        borderRadius:
          corners.value === "round"
            ? "var(--cr-border-radius-medium)"
            : "initial",
      };

      return styles;
    },
  },
};
